import { Button, Checkbox, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import CustomProductSelect from "../../unit/forms/CustomProductSelect";
import FieldTitle from "./FieldTitle";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import { useRecordContext } from "react-admin";
import CustomProductActionBottom from "../CustomProductActionBottom";

export default function ESignature({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const sectionName = "esignature";
  const sectionTitle = "E-Signature - Set requirements for signature";
  const sectionSubtitle = "";

  // const data = record?.data?.basic?.sectionName;
  const data = record?.data?.basic?.esignature;
  const productType = record?.data?.basic?.type;
  const subType = record?.data?.basic?.subType;
  const division = record?.data?.basic?.division;
  const productModulesGroup = record?.data?.basic?.productModulesGroup;

  const [showDetail, setShowDetail] = React.useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {},
  });
  React.useEffect(() => {
    if (data) {
      reset({
        sClosingPerform: data?.sClosingPerform || "Online",
        sESignatureMethod: data?.sESignatureMethod || "Disclaimer",
        sApplicationForm: data?.sApplicationForm || "NO",
      });
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = sectionName;
    // console.log("Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />

      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        {productModulesGroup?.includes("signature") && (
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <FieldTitle title="Signature method for application submission" />
            </Grid>
            <Grid item xs={4}>
              <Controller
                name="sESignatureMethod"
                control={control}
                defaultValue={data?.sESignatureMethod || ""}
                render={({ field }) => (
                  <CustomProductSelect
                    {...field}
                    fullWidth
                    variant="outlined"
                    optionlist={[
                      {
                        value: "Disclaimer",
                        label: "Check box with disclaimer",
                      },
                    ]}
                  />
                )}
              />
            </Grid>
            <Grid item xs={4}></Grid>
            <Grid item xs={4}>
              <FieldTitle title="Signature method for final agreement" />
            </Grid>
            <Grid item xs={4}>
              <Controller
                name="sClosingPerform"
                control={control}
                defaultValue={data?.sClosingPerform || ""}
                render={({ field }) => (
                  <CustomProductSelect
                    {...field}
                    fullWidth
                    variant="outlined"
                    optionlist={[
                      {
                        value: "Online",
                        label: "Online",
                      },
                      {
                        value: "IN-PERSON",
                        label: "In-Person",
                      },
                    ]}
                    sx={{ marginTop: "-6px" }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={4}></Grid>
            <Grid item xs={12}>
              <Controller
                name="sApplicationForm"
                control={control}
                render={({ field }) => (
                  <Checkbox
                    {...field}
                    size="small"
                    color="primary"
                    checked={field.value === "YES"}
                    onChange={(e) => {
                      field.onChange(e.target.checked ? "YES" : "NO");
                    }}
                  />
                )}
              />
              Include submitted application in the final agreement package for
              signature
            </Grid>
          </Grid>
        )}
      </Box>
      {/* Form Actions */}
      <CustomProductActionBottom>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveClick}
          disabled={!isDirty}
          sx={{ width: "120px", mt: 1 }}
        >
          Save
        </Button>
      </CustomProductActionBottom>
    </SectionStyled>
  );
}
